{
  "REPORT": {
    "HEADER": "Gespräche",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Daten konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
    "SUMMARY_FETCHING_FAILED": "Zusammenfassung konnte nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Auflösungsanzahl",
        "DESC": "( Gesamt )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Auflösungsanzahl",
        "DESC": "( Gesamt )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Übergabezählung",
        "DESC": "( Gesamt )"
      },
      "REPLY_TIME": {
        "NAME": "Wartezeit des Kunden",
        "TOOLTIP_TEXT": "Die Wartezeit beträgt {metricValue} (basierend auf {conversationCount} Antworten)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Letzten 7 Tage",
      "LAST_14_DAYS": "Letzten 14 Tage",
      "LAST_30_DAYS": "Letzte 30 Tage",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "Die letzten 3 Monate",
      "LAST_6_MONTHS": "Die letzten 6 Monate",
      "LAST_YEAR": "Letztes Jahr",
      "CUSTOM_DATE_RANGE": "Benutzerdefinierter Zeitraum"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Gruppieren nach",
    "DURATION_FILTER_LABEL": "Dauer",
    "GROUPING_OPTIONS": {
      "DAY": "Tag",
      "WEEK": "Woche",
      "MONTH": "Monat",
      "YEAR": "Jahr"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      },
      {
        "id": 2,
        "groupBy": "Woche"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      },
      {
        "id": 2,
        "groupBy": "Woche"
      },
      {
        "id": 3,
        "groupBy": "Monat"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      },
      {
        "id": 2,
        "groupBy": "Woche"
      },
      {
        "id": 3,
        "groupBy": "Monat"
      }
    ],
    "BUSINESS_HOURS": "Öffnungszeiten",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Filter löschen",
      "EMPTY_LIST": "Keine Ergebnisse gefunden"
    },
    "DRILLDOWN": {
      "TITLE": "{metric} details",
      "RESULT_COUNT_CONVERSATION": "{count} conversation | {count} conversations",
      "RESULT_COUNT_MESSAGE": "{count} message | {count} messages",
      "EMPTY": "No records found for this bar.",
      "ERROR": "Could not load records. Please try again.",
      "ADMIN_ONLY": "Only administrators can drill down into report records.",
      "LOAD_MORE": "Load more",
      "CLOSE": "Close details",
      "PREVIOUS_BUCKET": "Previous bar",
      "NEXT_BUCKET": "Next bar",
      "UNKNOWN_CONTACT": "Unknown contact",
      "UNKNOWN_INBOX": "Unknown inbox",
      "UNASSIGNED_AGENT": "Nicht zugewiesen",
      "NO_MESSAGE_CONTENT": "No message content",
      "MESSAGE_CREATED_AT": "Message created at {time}",
      "EVENT_OCCURRED_AT": "Event occurred at {time}",
      "INCOMING_MESSAGE": "Incoming message",
      "OUTGOING_MESSAGE": "Outgoing message"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agenten-Übersicht",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_AGENT_REPORTS": "Agenten-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Agent auswählen",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Agenten suchen"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Label-Übersicht",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "Diagrammdaten laden...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_LABEL_REPORTS": "Label-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Label auswählen",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "Labels suchen"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Posteingangsübersicht",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_INBOX_REPORTS": "Agenten-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Eingang auswählen",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team-Übersicht",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_TEAM_REPORTS": "Team-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Team auswählen",
    "FILTERS": {
      "ADD_FILTER": "Filter hinzufügen",
      "CLEAR_ALL": "Alle löschen",
      "NO_FILTER": "Keine Filter verfügbar",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "Teams suchen"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT-Berichte",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "CSAT-Berichte herunterladen",
    "DOWNLOAD_FAILED": "CSAT-Berichte konnten nicht heruntergeladen werden",
    "FILTERS": {
      "ADD_FILTER": "Filter hinzufügen",
      "CLEAR_ALL": "Alle löschen",
      "NO_FILTER": "Keine Filter verfügbar",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "Agenten suchen",
        "INBOXES": "Search inboxes",
        "TEAMS": "Teams suchen",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "Agent"
      },
      "INBOXES": {
        "LABEL": "Posteingang"
      },
      "TEAMS": {
        "LABEL": "Team"
      },
      "RATINGS": {
        "LABEL": "Bewertung"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Agent",
        "RATING": "Bewertung",
        "FEEDBACK_TEXT": "Feedback-Kommentar",
        "CONVERSATION": "Konversation",
        "CUSTOMER": "Customer",
        "RESPONSE": "Antwort",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Antworten gesamt",
        "TOOLTIP": "Anzahl aller gesammelten Antworten"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Zufriedenheitswert",
        "TOOLTIP": "Anzahl der positiven Antworten / Anzahl aller Antworten * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Antwortrate",
        "TOOLTIP": "Anzahl aller Antworten / Anzahl der gesendeten CSAT-Umfrage * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Speichern",
      "CANCEL": "Stornieren",
      "SAVING": "Speichern...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot-Berichte",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Anzahl der Konversationen",
        "TOOLTIP": "Gesamtzahl der vom Bot bearbeiteten Konversationen"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Gesamtanzahl Antworten",
        "TOOLTIP": "Gesamtzahl der vom Bot gesendeten Antworten"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Lösungsrate",
        "TOOLTIP": "Gesamtzahl der vom Bot gelösten Konversationen / Gesamtzahl der vom Bot bearbeiteten Konversationen * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Übergaberate",
        "TOOLTIP": "Gesamtzahl der an Agenten übergebenen Konversationen / Gesamtzahl der vom Bot bearbeiteten Konversationen * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Übersicht",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Offene Konversationen",
      "LOADING_MESSAGE": "Konversationsdaten werden geladen...",
      "OPEN": "Öffnen",
      "UNATTENDED": "Unbeaufsichtigt",
      "UNASSIGNED": "Nicht zugewiesen",
      "PENDING": "Ausstehend"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Gesprächsprotokoll",
      "NO_CONVERSATIONS": "Keine Konversation",
      "CONVERSATION": "{count} Konversation",
      "CONVERSATIONS": "{count} Konversationen",
      "DOWNLOAD_REPORT": "Bericht herunterladen"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "Keine Konversation",
      "CONVERSATION": "{count} Konversation",
      "CONVERSATIONS": "{count} Konversationen",
      "DOWNLOAD_REPORT": "Bericht herunterladen"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Konversationen von Agenten",
      "LOADING_MESSAGE": "Agent-Daten werden geladen...",
      "NO_AGENTS": "Es existieren keine Konversationen von Agenten",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Öffnen",
        "UNATTENDED": "Unbeaufsichtigt",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Öffnen",
        "UNATTENDED": "Unbeaufsichtigt",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agentenstatus",
      "ONLINE": "Online",
      "BUSY": "Beschäftigt",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sonntag",
    "MONDAY": "Montag",
    "TUESDAY": "Dienstag",
    "WEDNESDAY": "Mittwoch",
    "THURSDAY": "Donnerstag",
    "FRIDAY": "Freitag",
    "SATURDAY": "Samstag"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA-Berichte",
    "NO_RECORDS": "SLA-angewandte Unterhaltungen sind nicht verfügbar.",
    "LOADING": "Lade SLA-Daten...",
    "DOWNLOAD_SLA_REPORTS": "SLA-Berichte herunterladen",
    "DOWNLOAD_FAILED": "SLA-Berichte konnten nicht heruntergeladen werden",
    "DROPDOWN": {
      "ADD_FIlTER": "Filter hinzufügen",
      "CLEAR_ALL": "Alle löschen",
      "CLEAR_FILTER": "Filter löschen",
      "EMPTY_LIST": "Keine Ergebnisse gefunden",
      "NO_FILTER": "Keine Filter verfügbar",
      "SEARCH": "Suchfilter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA-Name",
        "AGENTS": "Agentenname",
        "INBOXES": "Posteingangsname",
        "LABELS": "Labelname",
        "TEAMS": "Teamname"
      },
      "SLA": "SLA-Richtlinie",
      "INBOXES": "Posteingang",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "mit",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Trefferquote",
        "TOOLTIP": "Prozentsatz der erstellten SLAs, die erfolgreich abgeschlossen wurden"
      },
      "NO_OF_MISSES": {
        "LABEL": "Anzahl der Verfehlungen",
        "TOOLTIP": "Gesamtanzahl der SLA-Verfehlungen in einem bestimmten Zeitraum"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Anzahl der Konversationen",
        "TOOLTIP": "Gesamtzahl der Konversationen mit SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Richtlinie",
        "CONVERSATION": "Konversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Details anzeigen"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "Posteingang",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Label",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Auflösungsanzahl",
    "CONVERSATIONS": "Anzahl der Konversationen"
  }
}
